module.exports = __webpack_public_path__ + "static/gallery_kerry_1-e03796d42ff7fc0bbab1a041fc12e9eb.jpg";